import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import type { UploadHookControl } from '@better-upload/client';
import { Loader2, Upload } from 'lucide-react';
import { useId } from 'react';
type UploadButtonProps = {
  control: UploadHookControl<true>;
  id?: string;
  accept?: string;
  metadata?: Record<string, unknown>;
  uploadOverride?: (...args: Parameters<UploadHookControl<false>['upload']>) => void;

  // Add any additional props you need.
};
export function UploadButton(t0) {
  const $ = _c(19);
  const {
    control: t1,
    id: _id,
    accept,
    metadata,
    uploadOverride
  } = t0;
  const {
    upload,
    isPending
  } = t1;
  const id = useId();
  const t2 = _id || id;
  const t3 = _id || id;
  let t4;
  if ($[0] !== isPending || $[1] !== metadata || $[2] !== upload || $[3] !== uploadOverride) {
    t4 = e => {
      if (e.target.files?.[0] && !isPending) {
        if (uploadOverride) {
          uploadOverride(e.target.files[0], {
            metadata
          });
        } else {
          upload([e.target.files[0]], {
            metadata
          });
        }
      }
      e.target.value = "";
    };
    $[0] = isPending;
    $[1] = metadata;
    $[2] = upload;
    $[3] = uploadOverride;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== accept || $[6] !== isPending || $[7] !== t3 || $[8] !== t4) {
    t5 = <input id={t3} disabled={isPending} className="absolute inset-0 size-0 opacity-0" type="file" accept={accept} onChange={t4} />;
    $[5] = accept;
    $[6] = isPending;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <label htmlFor={t2} className="absolute inset-0 cursor-pointer">{t5}</label>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isPending) {
    t7 = isPending ? <><Loader2 className="size-3.5 animate-spin mr-1.5" />Upload</> : <><Upload className="size-3.5 mr-1.5" />Upload</>;
    $[13] = isPending;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isPending || $[16] !== t6 || $[17] !== t7) {
    t8 = <Button disabled={isPending} className="relative h-8 text-xs px-2" type="button" size="sm">{t6}{t7}</Button>;
    $[15] = isPending;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}